import React from "react";

export function StatCard({ label, value, icon: Icon, accent = "primary", sub, testid }) {
  const accents = {
    primary: "text-primary bg-primary/10",
    success: "text-success bg-success/10",
    danger: "text-destructive bg-destructive/10",
    warning: "text-warning bg-warning/10",
  };
  return (
    <div className="data-card p-5" data-testid={testid}>
      <div className="flex items-start justify-between">
        <p className="overline">{label}</p>
        {Icon && (
          <div className={`h-8 w-8 rounded-md flex items-center justify-center ${accents[accent]}`}>
            <Icon className="h-4 w-4" strokeWidth={2} />
          </div>
        )}
      </div>
      <p className="font-mono text-2xl font-semibold mt-3 tracking-tight text-foreground" data-testid={testid ? `${testid}-value` : undefined}>
        {value}
      </p>
      {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
    </div>
  );
}
